export default __webpack_public_path__ + "static/media/app-notify-icon.9eee95b3.png";